module.exports = __webpack_public_path__ + "static/media/Team 14 - Workspace Clinic.81471b62.png";